import React, { useEffect, useState } from "react";
import "./TimeCount.css";
import _ from "lodash";
import moment from "moment";

export default function TimeCount(props) {

  const [matchup] = useState(props.matchup);
  const [timeCount, setTimeCount] = useState({});

  useEffect(() => {
    if (!_.isEmpty(props.timeCount)) {
      if (props.timeCount && Object.keys(props.timeCount).length > 0) {
        for (const key in props.timeCount) {
          
          if (Object.hasOwnProperty.call(props.timeCount, key)) {
            const element = props.timeCount[key];
            const temp = _.orderBy(Object.keys(element).map(x => ({ key: x, timestamp:  moment(x, 'hh:ss A').unix()})), ['timestamp']);
            let c = {};
            temp.forEach((current, key) => {
              c[current['key']] = element[current['key']];
            });
            props.timeCount[key] = c;
          }
        }
      }
      setTimeCount(props.timeCount);
    }
  }, [props.timeCount]);

  const teamName = (id) => {
    let name = '--';
    if (id && matchup && matchup.teamData) {
      name = matchup.teamData.find(x => +x.id === +id) ? matchup.teamData.find(x => +x.id === +id).name : '--';
    }
    return name;
  }

  return (
    <>
      <div className="count-wrapper">
        <h2>Time Count</h2>
        {
          timeCount &&
          !_.isEmpty(timeCount) &&
          Object.keys(timeCount).map((k, i) => (
            <div className="time-blk" key={`${k}-${i}`}>
              <h3>{teamName(k)}</h3>
              <ul>
                {
                  Object.keys(timeCount[k]).map((key, index) => (
                    <li key={index}>{key} - {timeCount[k][key]}</li>
                  ))
                }
              </ul>
            </div>
          ))
        }

      </div>
    </>
  );
}
